import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";

const ReeferExpress = () => {
  return (
    <>
      <Helmet>
        <title>Reefer Express | Trans World Shipping</title>
        <meta
          name="description"
          content="Experience reliable and efficient reefer freight services with Trans World Shipping."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/services/reefer-express"
        />
      </Helmet>

      <TheReeferExpress>
        <div className="reefer-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Reefer Express</h1>
            <p>Specialized temperature-controlled transportation solutions</p>
          </div>
        </div>

        <div className="reefer-container">
          <div className="intro-section">
            <p>
              <strong>Reefer Cargo services</strong> - a business with special
              requirements.
            </p>
          </div>

          <div className="commitment-section">
            <p>
              We are committed to provide integrated solutions to satisfy your
              door-to-door refrigerated transportation supply chain needs,
              whether frozen, chilled or temperature controlled.
            </p>
          </div>

          <div className="specifications-section">
            <p>
              Temperature-sensitive cargo must be shipped in accordance with
              strict specifications. Our staff ensures that your products get
              the best possible attention.
            </p>
          </div>

          <div className="equipment-section">
            <p>We utilize state-of-the-art equipment and monitoring systems.</p>
          </div>

          <div className="flexibility-section">
            <p>
              Our company size is crucial to guarantee great flexibility and
              will react promptly to changes in the market for your benefit.
            </p>
          </div>

          <div className="dedication-section">
            <p>
              We are operating weekly sailings and you will have one dedicated
              specialist assigned to you 24/7.
            </p>
          </div>

          <div className="services-list">
            <h3>Temperature-controlled transportation service include:</h3>
            <div className="service-items">
              <span className="service-tag">Door - Door service</span>
              <span className="service-tag">
                Global freight rates including crosstrades
              </span>
              <span className="service-tag">Price transparency</span>
              <span className="service-tag">Insurance</span>
            </div>
          </div>
        </div>
      </TheReeferExpress>
    </>
  );
};

const TheReeferExpress = styled.div`
  width: 100%;
  background: #ffffff;

  .reefer-hero {
    position: relative;
    width: 100%;
    height: 40vh;
    min-height: 300px;
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(
        circle at 30% 50%,
        rgba(212, 175, 55, 0.1) 0%,
        transparent 70%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .reefer-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .intro-section {
    text-align: center;
    margin-bottom: 2rem;

    p {
      font-size: 1.3rem;
      color: #0b1e33;
      font-weight: 600;

      strong {
        color: #d4af37;
      }
    }
  }

  .commitment-section {
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;

    p {
      color: white;
      font-size: 1.1rem;
      line-height: 1.7;
    }
  }

  .specifications-section,
  .equipment-section,
  .flexibility-section,
  .dedication-section {
    background: #f8f9fa;
    padding: 1.5rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.6;
    }
  }

  .services-list {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-top: 1rem;
    border: 1px solid #e2e8f0;

    h3 {
      font-size: 1.2rem;
      color: #0b1e33;
      margin-bottom: 1.5rem;
      font-weight: 600;
    }

    .service-items {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1rem;

      .service-tag {
        background: white;
        padding: 0.6rem 1.2rem;
        border-radius: 30px;
        font-size: 0.9rem;
        color: #0b1e33;
        border: 1px solid #d4af37;
        transition: all 0.3s ease;

        &:hover {
          background: #d4af37;
          color: white;
          transform: translateY(-2px);
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    .reefer-hero .hero-content h1 {
      font-size: 2.5rem;
    }

    .reefer-container {
      padding: 3rem 1.5rem;
    }

    .intro-section p {
      font-size: 1.1rem;
    }

    .commitment-section p {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 768px) {
    .reefer-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 2rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .reefer-container {
      padding: 2rem 1rem;
    }

    .intro-section p {
      font-size: 1rem;
    }

    .services-list .service-items {
      flex-direction: column;
      align-items: center;

      .service-tag {
        width: 100%;
        max-width: 250px;
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .reefer-hero .hero-content h1 {
      font-size: 1.6rem;
    }

    .commitment-section p,
    .specifications-section p,
    .equipment-section p,
    .flexibility-section p,
    .dedication-section p {
      font-size: 0.95rem;
    }

    .services-list h3 {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 480px) {
    .reefer-hero .hero-content h1 {
      font-size: 1.3rem;
    }

    .reefer-hero .hero-content p {
      font-size: 0.9rem;
    }
  }
`;

export default ReeferExpress;
